import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import Store from '../store/index';
import {User} from '@/oauth/User';
import {AuthTokenDto} from './AuthTokenDto';
import {Authority} from './Authority';
import {AuthToken} from '@/oauth/AuthToken';
import {UserDto} from '@/oauth/UserDto';

@Module({
    dynamic: true,
    store: Store,
    name: 'AuthStore',
})
export class AuthStore extends VuexModule {
    public loginUser: User = new User();
    public authorities: Authority[] = [];
    public isRegisterSuccess = false;

    @Mutation
    public setIsRegisterSuccess(value: boolean){
        this.isRegisterSuccess=value;
    }

    @Mutation
    public setLoginUser(user: User) {
        this.loginUser = user;
    }

    @Action
    public async updateLoginUser() {
        const user = await UserDto.findByUsername(AuthTokenDto.getOrLogin().getUsername());
        this.setLoginUser(user);
        localStorage.setItem("user",JSON.stringify(user));
        return true;
    }

    @Mutation
    public setAuthorities(authorities: Authority[]) {
        this.authorities = authorities;
    }

    //本方法会导致未登录用户强制登录
    public get token(): AuthToken {
        return AuthTokenDto.getOrLogin();
    }


}
